import React, { Fragment } from "react";
import { BLOCKS, MARKS, INLINES } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import PropTypes from "prop-types";
import { css } from "styled-components";
import { Flex, Box, Text } from "rebass";
import { Heading } from "../../components/Text";
import { ColorOverlay } from "../../components/ui/ColorOverlay";
import SEO from "../../components/seo";

const PageHeading = ({ children, ...props }) => (
  <Text as="h3" pb={0} mb={0} {...props}>
    {children}
  </Text>
);

PageHeading.propTypes = {
  children: PropTypes.node,
};
/* eslint-disable */
const options = {
  renderMark: {
    [MARKS.BOLD]: (text) => (
      <Text as="strong" fontWeight="bold">
        {text}
      </Text>
    ),
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <Text as="p" mb={3}>
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_1]: (node, children) => (
      <PageHeading as="h1">{children}</PageHeading>
    ),
    [BLOCKS.HEADING_2]: (node, children) => (
      <PageHeading as="h2" mb={3}>
        {children}
      </PageHeading>
    ),
    [BLOCKS.HEADING_3]: (node, children) => (
      <PageHeading as="h3" mb={3}>
        {children}
      </PageHeading>
    ),
    [BLOCKS.HEADING_4]: (node, children) => (
      <PageHeading as="h4" mb={3}>
        {children}
      </PageHeading>
    ),
    [BLOCKS.HEADING_5]: (node, children) => (
      <PageHeading as="h5" mb={3}>
        {children}
      </PageHeading>
    ),
    [BLOCKS.HEADING_6]: (node, children) => (
      <PageHeading as="h6" mb={3}>
        {children}
      </PageHeading>
    ),
    [INLINES.ASSET_HYPERLINK]: (node) =>
      `<img class='custom-asset' src="${node.data.target.fields.file["en-US"].url}"/>`,
    [INLINES.EMBEDDED_ENTRY]: (node) => (
      <a href={node.data.target.fields.link["en-US"]}>
        {node.data.target.fields.title["en-US"]}
      </a>
    ),
  },
};
/* eslint-enable */

const d = ({ description }) =>
  documentToReactComponents(JSON.parse(description?.raw), options);

const SecondPage = ({ pageContext }) => {
  const a = d(pageContext);
  return (
    <Fragment>
      <SEO title={pageContext.title} />
      <Flex
        width={[1]}
        flexDirection={["column"]}
        alignItems={[
          "normal",
          "normal",
          "normal",
          "normal",
          "normal",
          "flex-end",
        ]}
        justifyContent="flex-end"
        mx={[0, 0, "auto"]}
        color="white"
        pt={[3, 4]}
        pb={4}
        css={css`
          max-width: 860px;
          min-height: 100vh;
          z-index: 1;
          position: relative;
        `}
      >
        <Box width={["auto", "auto", "auto", "auto", "auto", 4 / 5]} pb={6}>
          <Heading as="h1">{pageContext.title}</Heading>
          <div>{a}</div>
        </Box>
      </Flex>
      <ColorOverlay
        colors={[
          "rgba(0, 0, 0, 0.9)",
          "rgba(0, 0, 0, 0.9)",
          "rgba(0, 0, 0, 0.9)",
        ]}
      />
    </Fragment>
  );
};

SecondPage.propTypes = {
  pageContext: PropTypes.object.isRequired,
};

export default SecondPage;
